import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["navigation", "hamburger", "close", "dropdown", "dropdownButton", "dropdownMenu"]

  connect() {
    this.overlayElement = document.getElementById('mobile-overlay')
    this.handleDocumentClick = this.handleDocumentClick.bind(this)
    this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this)
    this.lastPointerToggleAt = 0

    document.addEventListener("click", this.handleDocumentClick)
    document.addEventListener("keydown", this.handleDocumentKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.handleDocumentClick)
    document.removeEventListener("keydown", this.handleDocumentKeydown)
    document.body.style.overflow = ""
  }

  toggleMobile() {
    const isMenuHidden = this.navigationTarget.classList.contains("-right-full")

    this.navigationTarget.classList.toggle("-right-full")
    this.navigationTarget.classList.toggle("right-0")
    this.overlayElement?.classList.toggle("opacity-0")
    this.overlayElement?.classList.toggle("invisible")

    this.hamburgerTarget.classList.toggle("hidden")
    this.closeTarget.classList.toggle("hidden")

    if (isMenuHidden) {
      this.closeDropdowns()
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflow = ""
    }
  }

  toggleDropdown(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.shouldIgnoreCompatibilityClick(event)) return

    if (event.type === "pointerup") {
      this.lastPointerToggleAt = Date.now()
    }

    const dropdown = event.currentTarget.closest("[data-navigation-target~='dropdown']")
    if (!dropdown) return

    if (dropdown.classList.contains("is-open")) {
      this.closeDropdown(dropdown)
    } else {
      this.closeDropdowns()
      this.openDropdown(dropdown)
    }
  }

  handleDropdownKeydown(event) {
    if (event.key !== "ArrowDown") return

    event.preventDefault()

    const dropdown = event.currentTarget.closest("[data-navigation-target~='dropdown']")
    if (!dropdown) return

    this.closeDropdowns()
    this.openDropdown(dropdown)
    dropdown.querySelector("[data-navigation-target~='dropdownMenu'] a")?.focus()
  }

  hideMobileMenu() {
    this.closeDropdowns()

    if (!this.navigationTarget.classList.contains("right-0")) return

    this.navigationTarget.classList.add("-right-full")
    this.navigationTarget.classList.remove("right-0")
    this.overlayElement?.classList.add("opacity-0", "invisible")
    this.hamburgerTarget.classList.remove("hidden")
    this.closeTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  handleDocumentClick(event) {
    if (this.element.contains(event.target)) return

    this.closeDropdowns()
  }

  handleDocumentKeydown(event) {
    if (event.key !== "Escape") return

    this.closeDropdowns()
    this.hideMobileMenu()
  }

  openDropdown(dropdown) {
    dropdown.classList.add("is-open")
    dropdown.querySelector("[data-navigation-target~='dropdownMenu']")?.classList.remove("lg:opacity-0", "lg:invisible")
    dropdown.querySelector("[data-navigation-target~='dropdownMenu']")?.classList.add("lg:opacity-100", "lg:visible")
    dropdown.querySelector("[data-dropdown-icon]")?.classList.add("lg:rotate-180")
    dropdown.querySelector("[data-navigation-target~='dropdownButton']")?.setAttribute("aria-expanded", "true")
  }

  closeDropdown(dropdown) {
    dropdown.classList.remove("is-open")
    dropdown.querySelector("[data-navigation-target~='dropdownMenu']")?.classList.add("lg:opacity-0", "lg:invisible")
    dropdown.querySelector("[data-navigation-target~='dropdownMenu']")?.classList.remove("lg:opacity-100", "lg:visible")
    dropdown.querySelector("[data-dropdown-icon]")?.classList.remove("lg:rotate-180")
    dropdown.querySelector("[data-navigation-target~='dropdownButton']")?.setAttribute("aria-expanded", "false")
  }

  closeDropdowns() {
    this.dropdownTargets.forEach((dropdown) => this.closeDropdown(dropdown))
  }

  shouldIgnoreCompatibilityClick(event) {
    return event.type === "click" && Date.now() - this.lastPointerToggleAt < 500
  }
}
